<script setup lang="ts">
  const emit = defineEmits(['leave', 'back']);

  const onLeave = () => {
    emit('leave');
  };

  const onBack = () => {
    emit('back');
  };
</script>

<template>
  <div class="chat-leave modal-container">
    <div class="chat-leave-modal">
      <div class="chat-leave-modal__wrapper">
        <div class="chat-leave-modal__bottom">
          <button
            class="chat-leave-modal__back"
            @click.prevent.stop="onBack">
            {{ $t('chat.leaveModal.backToChat') }}
          </button>
          <button
            class="chat-leave-modal__leave"
            @click.prevent.stop="onLeave">
            {{ $t('chat.leaveModal.leaveAiMode') }}
          </button>
        </div>
        <div class="chat-leave-modal__left">
          <div class="chat-leave-modal__form">
            <h2>{{ $t('chat.leaveModal.title') }}</h2>
            <p>{{ $t('chat.leaveModal.text') }}</p>
            <ChatLeaveForm @submit="onLeave" />
          </div>
        </div>
        <div class="chat-leave-modal__right">
          <div class="chat-leave-modal__info">
            <h1>{{ $t('chat.leaveModal.infoTitle') }}</h1>
            <p>
              {{ $t('chat.leaveModal.infoText') }}
            </p>
            <div class="chat-leave-modal__right-buttons">
              <button
                class="chat-leave-modal__back"
                @click.prevent.stop="onBack">
                {{ $t('chat.leaveModal.backToChat') }}
              </button>
              <button
                class="chat-leave-modal__leave"
                @click.prevent.stop="onLeave">
                {{ $t('chat.leaveModal.leaveAiMode') }}
              </button>
            </div>
            <a
              class="chat-leave-modal__close"
              @click.prevent.stop="onBack" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
